import type { ReactNode } from 'react';
import type { RouteLoader, RouteModule } from './routeEntries.types';

export function lazyLoad<Module extends RouteModule>(importFn: RouteLoader<Module>) {
  return {
    lazy: async () => {
      try {
        const module = await importFn();
        sessionStorage.removeItem('chunkReloadAttempted');
        return { Component: module.default };
      } catch (error) {
        if (!sessionStorage.getItem('chunkReloadAttempted')) {
          sessionStorage.setItem('chunkReloadAttempted', '1');
          window.location.reload();
          return { Component: () => null };
        }
        throw error;
      }
    },
  };
}

export function lazyLoadWithProps<Modules extends readonly unknown[]>(
  importFns: { [Index in keyof Modules]: () => Promise<Modules[Index]> },
  buildComponent: (...modules: Modules) => ReactNode
) {
  return {
    lazy: async () => {
      try {
        const modules = await Promise.all(importFns.map((importFn) => importFn()));
        sessionStorage.removeItem('chunkReloadAttempted');
        return { Component: () => buildComponent(...(modules as unknown as Modules)) };
      } catch (error) {
        if (!sessionStorage.getItem('chunkReloadAttempted')) {
          sessionStorage.setItem('chunkReloadAttempted', '1');
          window.location.reload();
          return { Component: () => null };
        }
        throw error;
      }
    },
  };
}